// import React from "react";
// import { Link } from "react-router-dom";
// import "bootstrap/dist/css/bootstrap.css";
// import DropdownMenu from "../Components/Dropdown";
// import Partners from "../pages/Partners";
// import origi from "../assests/origi.mp4";
// import logo from "../assests/logoo.png";

// const Header = () => {
//   return (
//     <div>
//       {/* شريط علوي رفيع */}
//       <div className="header-top h-[35px] bg-gradient-to-l from-blue-800 to-blue-300 w-full mt-0" />

//       <header>
//         <nav className="font-cairo fixed top-0 w-full h-[55px] bg-white/90 backdrop-blur-md shadow-sm transition-all duration-500 z-50">
//           <div className="flex flex-wrap items-center mx-auto max-w-screen-xl px-6">
//             {/* اللوجو */}
//             <div className="flex items-center mr-auto">
//               <Link to="/" className="flex items-center">
//                 <img
//                   src={logo}
//                   alt="Logo"
//                   className="h-14 p-1 w-auto object-contain"
//                 />
//               </Link>
//             </div>

//             {/* قائمة اللينكات */}
//             <div
//               className="hidden lg:flex items-center space-x-8"
//               id="desktop-menu"
//             >
//               <Link
//                 to="/"
//                 className="text-blue-900 font-medium text-base relative group no-underline"
//               >
//                 Home
//                 <span className="absolute left-0 -bottom-0.5 w-0 h-[2px] bg-blue-900 transition-all duration-300 group-hover:w-full"></span>
//               </Link>

//               {/* <DropdownMenu />
//               <Partners /> */}

//               <Link
//                 to="/company"
//                 className="text-blue-900 font-medium text-base relative group no-underline"
//               >
//                 Projects
//                 <span className="absolute left-0 -bottom-0.5 w-0 h-[2px] bg-blue-900 transition-all duration-300 group-hover:w-full"></span>
//               </Link>

//               <Link
//                 to="/partnerships"
//                 className="text-blue-900 font-medium text-base relative group no-underline"
//               >
//                 Partners
//                 <span className="absolute left-0 -bottom-0.5 w-0 h-[2px] bg-blue-900 transition-all duration-300 group-hover:w-full"></span>
//               </Link>

//               <Link
//                 to="/about"
//                 className="text-blue-900 font-medium text-base relative group no-underline"
//               >
//                 About Us
//                 <span className="absolute left-0 -bottom-0.5 w-0 h-[2px] bg-blue-900 transition-all duration-300 group-hover:w-full"></span>
//               </Link>
//             </div>
//           </div>
//         </nav>
//       </header>
//     </div>
//   );
// };

// export default Header;

import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FaBars, FaTimes, FaPhoneAlt } from "react-icons/fa";
import logo from "../assests/LogoDtec.png";

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);

  const navItems = [
    { to: "/", label: "Home" },
    { to: "/company", label: "Projects" },
    { to: "/partnerships", label: "Partners" },
    { to: "/services", label: "Services" },
    // { to: "/career", label: "Careers" },        // to be continued
    { to: "/about", label: "About Us" },
    {
      to: "/contact",
      label: "Contact Us",
      icon: <FaPhoneAlt className="mr-2 text-blue-900" />, // الأيقونة قبل النص
    },
  ];

  return (
    <div>
      {/* الشريط العلوي */}
      <div className="h-[35px]" />
      <header>
        <nav className="font-cairo fixed top-0 w-full h-[65px] bg-white/90 backdrop-blur-md shadow-md z-50 transition-all duration-500">
          <div className="flex items-center justify-between mx-auto max-w-screen-xl px-6 h-full">
            {/* اللوجو */}
            <Link to="/" className="flex items-center">
              <img
                src={logo}
                alt="Logo"
                className="h-14 w-auto object-contain"
              />
            </Link>

            {/* القائمة للـ Desktop */}
            <div className="hidden lg:flex items-center space-x-8">
              {navItems.map((item, index) => (
                <Link
                  key={index}
                  to={item.to}
                  className="text-blue-900 font-medium text-base relative group no-underline transition flex items-center"
                >
                  {item.icon && item.icon}
                  {item.label}
                  <span className="absolute left-0 -bottom-0.5 w-0 h-[2px] bg-blue-900 transition-all duration-300 group-hover:w-full"></span>
                </Link>
              ))}
            </div>

            {/* زرار الموبايل */}
            <button
              className="lg:hidden text-blue-900 text-2xl focus:outline-none"
              onClick={() => setIsOpen(!isOpen)}
            >
              {isOpen ? <FaTimes /> : <FaBars />}
            </button>
          </div>

          {/* القائمة للموبايل */}
          {isOpen && (
            <div className="lg:hidden absolute top-[55px] left-0 w-full bg-white shadow-md flex flex-col items-center py-4 space-y-4">
              {navItems.map((item, index) => (
                <Link
                  key={index}
                  to={item.to}
                  className="text-blue-900 font-medium text-lg hover:text-blue-600 transition flex items-center"
                  onClick={() => setIsOpen(false)}
                >
                  {item.icon && item.icon}
                  {item.label}
                </Link>
              ))}
            </div>
          )}
        </nav>
      </header>
    </div>
  );
};

export default Header;
